import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  // Define your styles here
  ul: {
    background: theme.palette.card.cardColor,
    color: theme?.palette?.card?.cardFontColor,
    "& ul": {
      color: theme.palette.card.cardFontColor,
      background: theme.palette.card.cardColor,
    },
  },
  selectMenu: {
    background: theme.palette.card.cardColor,
    "& li": {
      color: theme.palette.card.cardFontColor,
    },
  },
}));

function Index({
  slots,
  className,
  value,
  onChange,
  date,
  shouldFilter = false,
  orderTimeType = "shedulued",
  onClick,
  isFromCheckout = false,
  typeChanges = false,
  setNewChange,
  newChange = false,
  setTime,
}) {
  const classes = useStyles();
  const { checkoutDetails } = useSelector((state) => state.cart);
  const [timeslots, setTimeSlots] = useState(slots);
  
  // Use value prop if provided, otherwise use checkoutDetails
  const timeToMatch = value?.value || checkoutDetails?.deliveryTime;
  const formattedTime = timeToMatch ? moment(timeToMatch).format("hh:mm a").toLowerCase() : null;
  
  // Find and set the slot based on the formatted time
  let matchedSlot = slots?.find((slot) => slot?.value === formattedTime);
  const [timeChanges, setTimeChanges] = useState(false);

  if (
    // !isFromCheckout &&
    checkoutDetails?.deliveryType === "ASAP" &&
    !matchedSlot
  ) {
    matchedSlot = slots?.find((slot) => slot?.typeOfOrder === "ASAP");
  } else if (
    // !isFromCheckout &&
    checkoutDetails?.deliveryType === "SCHEDULED" &&
    !matchedSlot
  ) {
    matchedSlot = slots?.find((slot) => slot?.typeOfOrder === "SCHEDULED");
  }
  const [selectedDate, setSelectedDate] = useState(matchedSlot || {});

  // Always keep selectedDate in sync with the most current value
  useEffect(() => {
    // Priority 1: Use value prop if provided
    if (value && value.value) {
      setSelectedDate(value);
      return;
    }
    
    // Priority 2: Use Redux state if available
    if (isFromCheckout && checkoutDetails?.deliveryTime) {
      console.log("checkoutDetails?.deliveryTime",checkoutDetails.deliveryTime)
      const deliveryTime = moment(checkoutDetails.deliveryTime);
      const formattedTime = deliveryTime.format("hh:mm a").toLowerCase();
      console.log("formattedTime",formattedTime)
      const matchedSlot = slots?.find((slot) => {
        if (!slot.value) return false;
        console.log("slot.value",slot.value)
        const slotTime = moment(slot.value);
        if (slotTime.isValid()) {
          return slotTime.isSame(deliveryTime, 'minute');
        }
        
        return slot.value.toLowerCase().includes(formattedTime);
      });
      console.log("matchedSlot",matchedSlot)
      
      if (matchedSlot) {
        setSelectedDate(matchedSlot);
        // Also update parent's time state if setTime is available
        if (setTime) {
          setTime(matchedSlot.value);
        }
        return;
      }
    }
    
    // Priority 3: Use matchedSlot from props if available
    if (matchedSlot) {
      setSelectedDate(matchedSlot);
      // Also update parent's time state if setTime is available
      if (setTime) {
        setTime(matchedSlot.value);
      }
      return;
    }
    
    // Priority 4: Use first available slot if nothing else is selected
    if (slots && slots.length > 0 && !selectedDate?.value) {
      setSelectedDate(slots[0]);
      // Also update parent's time state if setTime is available
      if (setTime) {
        setTime(slots[0].value);
      }
    }
  }, [value, checkoutDetails?.deliveryTime, slots, matchedSlot, isFromCheckout, selectedDate?.value, setTime]);

  const filteredTimeSlots = (arry) => {
    return arry?.filter((item) => item.typeOfOrder !== "ASAP");
  };

  useEffect(() => {
    if (shouldFilter && slots) {
      setTimeSlots(filteredTimeSlots(slots));
    } else {
      setTimeSlots(slots);
    }
  }, [slots, shouldFilter]);

  useEffect(() => {
    if (
      checkoutDetails?.orderType &&
      slots.length > 0 &&
      isFromCheckout &&
      typeChanges &&
      !timeChanges &&
      !value?.value // Don't auto-select if value prop is provided
    ) {
      // Set the first slot as the default selected when orderType changes
      const firstSlot = slots[0];
      setSelectedDate(firstSlot);

      onChange(firstSlot, "time"); // Trigger onChange for the new selected slot

      setNewChange(true);
    }
  }, [
    checkoutDetails?.orderType,
    slots,
    isFromCheckout,
    typeChanges,
    timeChanges,
    value?.value, // Add value prop to dependencies
  ]);

  // useEffect(() => {
  //   if (selectedDate?.value && !slots.includes(selectedDate)) {
  //     /* ########################
  //       handle rerender of this component on deliverydate updation from delivery time slot generating hooks
  //       this results in creation of new slots which fails to match the object in our selectedDate state.
  //       This is a hack only
  //       #########################
  //     */
  //     const match = slots?.find((s) => s.value === selectedDate.value);
  //     if (match) {
  //       return setSelectedDate(match);
  //     }
  //   }

  //   const SelectedTimeFromSlots = slots?.find(
  //     (s) => s.value === selectedDate.value
  //   );
  //   if (!SelectedTimeFromSlots) {
  //     const data = slots[0];
  //     if (data) {
  //       setSelectedDate(data);
  //       onChange(data, "time");
  //     }

  //     return;
  //   }

  //   if (shouldFilter && orderTimeType !== "asap") {
  //     if (selectedDate?.value) {
  //       onChange(selectedDate, "time");
  //     } else {
  //       const data = slots[0];
  //       if (data) {
  //         setSelectedDate(data);
  //         onChange(data, "time");
  //       }
  //     }
  //   }
  // }, [selectedDate, slots, orderTimeType]);

  const sortTimeSlots = (slots) => {
    // Filter out slots with invalid time properties before sorting
    const validSlots = slots.filter(slot => slot && slot.time && typeof slot.time === 'string');
    
    return validSlots.sort((a, b) => {
      // Convert time strings to minutes for proper chronological sorting
      const timeToMinutes = (timeStr) => {
        // Handle undefined, null, or empty time strings
        if (!timeStr || typeof timeStr !== 'string') {
          return 0; // Default to 0 minutes for invalid time strings
        }
        
        const timeParts = timeStr.split(':');
        if (timeParts.length < 2) {
          return 0; // Default to 0 minutes for invalid time format
        }
        
        const [hours, minutes] = timeParts.map(Number);
        return hours * 60 + minutes;
      };
      return timeToMinutes(a.time) - timeToMinutes(b.time);
    });
  };

  // Assuming `timeslots` is your original array of objects
  const sortedTimeSlots = sortTimeSlots(timeslots);

  return (
    <FormControl variant="outlined" className={className}>
      {/* <InputLabel id="delivery-time">Time</InputLabel> */}
      <Select
        labelId="delivery-time"
        id="delivery-time-select"
        value={selectedDate?.value || ""}
        onChange={(e) => {
          const selected = timeslots.find(
            (slot) => slot.value === e.target.value
          );
          setSelectedDate(selected);
          if (selected) {
            onChange(selected, "time");
            setTimeChanges(true);
          }
        }}
        onClick={(e) => {
          onClick();
          setTimeChanges(true);
        }}
        label="Time"
        MenuProps={{
          classes: { paper: classes.selectMenu },
        }}
        className={`font-weight-bold ${classes.ul}`}
      >
        {sortedTimeSlots?.map((elem, key) => (
          <MenuItem key={`option-${key}`} value={elem.value}>
            {elem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

Index.defaultProps = {
  buffer: null,
  value: null,
  onChange: () => {},
  slots: [],
  shouldFilter: false,
  orderTimeType: "scheduled",
  onClick: () => {},
  isFromCheckout: false,
  typeChanges: false,
  setNewChange: () => {},
  newChange: false,
  setTime: () => {},
};

Index.propTypes = {
  buffer: PropTypes.number,
  className: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func,
  slots: PropTypes.array,
  shouldFilter: PropTypes.bool,
  orderTimeType: PropTypes.string,
  onClick: PropTypes.func,
  isFromCheckout: PropTypes.bool,
  typeChanges: PropTypes.bool,
  setNewChange: PropTypes.func,
  newChange: PropTypes.bool,
  setTime: PropTypes.func,
};

export default Index;

